import security from "@/main";
import Core from "@/modules/core/service/Core";
import { getApiBaseUrl } from "@/config";
import { filenameFrom } from "@/modules/core/service/private/Filename";

const handleResponse = function (response, success, error) {
    if (!response.ok) {
        if (response.status === 401) {
            this.logout();
        } else {
            if (error) {
                response.json().then (msg => {
                    error(msg);
                })
            }
        }

        return Promise.reject();
    }

    return response.blob().then(blob => {
        const filename = filenameFrom(response, "report", "pdf");

        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
        const url =  URL.createObjectURL(data);
        let link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();

        success(filename, url);
    })
}


const url = {
    report  : "/api/report",
    perform : "/api/report/{0}",
    jasper  : "/api/incident/{0}/report",
    incident: "/api/incident/report",
    data    : "/api/incident/report/{0}/incident/{1}?index={2}"
};

export default {
    perform (reportId, format, parameter,  success, error) {
        fetch(getApiBaseUrl() + url.perform.replace("{0}", reportId), {
            method : "POST",
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                format   : format,
                parameter: parameter
            })
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    createPdf (incidentId, data,  success, error) {
        fetch(getApiBaseUrl() + url.jasper.replace("{0}", incidentId), {
            method : "POST",
            headers: security.jsonHeader(),
            body   : JSON.stringify(data)
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    getData (reportId, incidentId, index) {
        return Core.method.get(url.data, reportId, incidentId, index);
    },


    performPdf (reportId, incidentId, index,  success, error) {
        fetch(getApiBaseUrl() + url.incident, {
            method : "POST",
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                report  : reportId,
                incident: incidentId,
                index   : index
            })
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    customer (component, report, parameter, configuration) {
        if (report.id !== 104) {
            return false;
        }

        component.loading = true;
        Core.transfer.loadPost("/api/report/customer", {
            customerId   : parameter[0].value.id,
            from         : parameter[1].dateValue,
            to           : parameter[2].dateValue,
            locale       : parameter[3].strValue,
            configuration: configuration,
        }, ((blob) => {
            const link = document.createElement("a");
            link.href =blob;
            link.download = "Overview.pdf";
            link.click();
            component.loading = false;
        }), () => {
            component.loading = false;
        });

        return true;
    },
}